import { ActionTypes } from '../constants'

const defaultState = { error: null, errorType: null }

const api = (state = defaultState, action) => {
  switch(action.type) {
  case ActionTypes.API_ERROR:
  case ActionTypes.ACCESS_DENIED:
  case ActionTypes.NETWORK_ERROR:
    return { ...state, error: action.error, errorType: action.type }

  case ActionTypes.CLEAR_API_ERRORS:
    return defaultState

  default:
    return state
  }
}

export default api
